import { Component, Input, OnInit } from '@angular/core';

import { GoogleAnalyticsService } from '@app/services/_index';
import { LearningPlanTilesFactory } from '@app/factories/_index';
import { LearningPlanTilesItem } from '@app/models/_index';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-learning-plan-tiles',
  templateUrl: './learning-plan-tiles.component.html',
  styleUrls: ['./learning-plan-tiles.component.scss'],
  standalone: false,
})
export class LearningPlanTilesComponent implements OnInit {
  @Input() isLightMode = false; // Toggle to change background styling from light or dark
  learningPlanTiles: LearningPlanTilesItem[] = [];

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private learningPlanTilesFactory: LearningPlanTilesFactory
  ) {}

  ngOnInit(): void {
    this.learningPlanTiles = this.learningPlanTilesFactory.getCollection();
  }

  /**
   * Add Track By Learning Plan Tile Item to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of learningPlanTiles array
   * @param item - Learning Plan Tile item
   * @returns Learning Plan title
   */
  trackByLearningPlanTileItem(index: string, learningPlan: LearningPlanTilesItem): string {
    if (learningPlan) {
      return learningPlan.title;
    } else {
      return String(index);
    }
  }

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }
}
